export default {
  save_exit: 'Save & Exit',
  activate: 'Activate',
  send_a_test: 'Send a test',
  bonus_points_card: {
    title: 'Number of bonus points',
    label: 'How many bonus %{currencyName} customers get',
  },
  description_card: {
    title: 'Offer title',
    label: 'Text customers see',
    label_info:
      'Enter the text your customers will see when they view this offer in the app or in your email.',
    get_a_an: 'Get a/an',
    get: 'Get',
    required_error: 'Offer text can’t be empty',
    min_length_error: 'Please enter at least %{minLength} characters',
    max_length_error:
      'Offer description cannot contain more than %{maxLength} characters',
    example: 'example',
    not_editable:
      'This field may not be editable after a campaign issues offers using this template',
    add: 'Add description',
    optional: 'Optional description on the offer detail screen',
    remove: 'Remove description',
    optional_placeholder: 'Enter description',
  },
  fixed_price_card: {
    title: 'Fixed price',
    free_variant_title: 'Pricing',
    free_variant_description:
      'The discount covers the full price of the eligible item.',
    price_cap_label: 'Customer pays',
    price_cap_info:
      'The fixed price customers pay for eligible items. The discount is the difference between the item price and this amount.',
    price_cap_info_eg_1: 'Example:',
    price_cap_info_eg_2:
      'If an item costs $12 and you set this amount to $5, the customer will receive a $7 discount.',
    price_cap_info_eg_3:
      'If an item costs $3 and you set this amount to $5, the customer will continue to pay $3.',
    dollar: '$',
    help_text:
      'For example, if an item costs $12 and you set the price to $5.99, customers get a $6.01 discount.',
    discount_scope_label: 'Fixed price applies to',
    discount_scope_base_item_plus_all_modifiers: 'Item + any modifiers',
    discount_scope_base_item_plus_all_modifiers_help:
      'The customer pays the fixed price for the item including any modifiers.',
    discount_scope_base_item: 'Base item only',
    discount_scope_base_item_help:
      'Modifiers are charged at full price on top of the fixed item price.',
    discount_scope_base_item_plus_discounted_modifiers:
      'Item + modifier discounts',
    discount_scope_base_item_plus_discounted_modifiers_help:
      'The customer pays the fixed price for the item and the least expensive modifier discount on it. Choose the modifier discounts below. Any other modifiers cost their normal list price.',
    discount_scope_base_item_plus_required_modifiers:
      'Item + selected modifiers',
    discount_scope_base_item_plus_required_modifiers_help:
      'Select the modifiers that are eligible for the fixed price below. The customer pays the fixed price for the item and any of the selected modifiers. The customer pays full price for any modifiers not selected.',
    discount_scope_required_modifiers: 'Modifier only',
    discount_scope_required_modifiers_help:
      'The customer pays the fixed price for the modifier only.',
    discount_scope_required_modifiers_title:
      'Fixed price applied to modifiers only',
    discount_scope_required_modifiers_description:
      'The customer pays the fixed price for the modifiers, not the main item.',
    discount_config_title: "What's free",
    discount_config_subtitle: "Choose how this item's modifiers are treated.",
    discount_config_base_item_title: 'Just the item is free',
    discount_config_base_item_description: 'Customer pays for every modifier.',
    discount_config_required_modifiers_title:
      'The item and all the modifiers you list are free',
    discount_config_required_modifiers_description:
      'Every listed modifier on the item is included for free. Customer pays for all other modifiers.',
    discount_config_discounted_modifiers_title:
      'The item and the modifiers you choose are free',
    discount_config_discounted_modifiers_description:
      'The cheapest modifier from a list you manage applies automatically. Customer pays for all other modifiers.',
    discount_config_all_modifiers_title:
      'The item and all its modifiers are free',
    discount_config_all_modifiers_description:
      'Every modifier on the selected items is included for free.',
  },
  delivery_discount_card: {
    title: 'Discount',
    subtitle:
      'Choose how the offer lowers the delivery fee. Customers who order delivery and meet the minimum see the offer applied at checkout.',
    mode_group_label: 'How the offer lowers the delivery fee',
    mode_amount_label: 'Get $ off delivery fee',
    mode_percent_label: 'Get % off delivery fee',
    mode_fixed_label: 'Fixed delivery fee',
    mode_amount_help:
      'For example, enter 10 if you want to give customers a $10 discount.',
    mode_percent_help:
      'For example, enter 10 if you want to give customers a 10% discount.',
    mode_fixed_help:
      'For example, enter 0 to make delivery free, or 0.99 to charge customers $0.99.',
    discount_amount_label: 'Discount amount',
    delivery_fee_label: 'Delivery fee',
    dollar: '$',
    percent: '%',
    percent_must_be: 'Discount must be between 1% and 100%',
  },
  discount_card: {
    title: 'Discount',
    discount_amount: 'Discount amount',
    discount_info_dollar:
      'For example, enter 10 if you want to give customers a $10 discount.',
    discount_info_percent:
      'For example, enter 10 if you want to give customers a 10% discount.',
    retail_price_label: 'Retail price',
    retail_price_info:
      'What you normally charge customers for this item. It’s the price they pay without any discounts or offers.',
    dollar: '$',
    percent: '%',
    percent_must_be: 'Discount must be between 1% and 100%',
    limit_to_250$:
      'If you’re using statement credits then the maximum discount you can offer is $250',
  },
  item_value_card: {
    title: 'Cost of offer',
    subtitle: 'Configure the cost of this offer for reporting.',
    cost_to_business_label: 'Cost to business',
    cost_to_business_info:
      'What it costs your business to produce this item, including materials and labor.\nFor example, if you’re selling a burger, the cost to business would be the cost of the buns, meat, cheese, veggies.\nIf you don’t know this, a good rule of thumb is 30% of the retail price.',
    cost_to_business_info_v2:
      'What it costs your business to produce this item.\nFor example, if you’re selling a burger, the cost to the business would be the cost of the buns, meat, cheese, veggies.\nIf you don’t know this, a good rule of thumb is 50% of the retail price.',
    retail_price_label: 'Retail price',
    retail_price_info:
      'What you normally charge customers for this item. It’s the price they pay without any discounts or offers.',
    dollar: '$',
  },
  modifier_value_card: {
    title: 'Modifier Value',
    subtitle: 'Configure the cost of this modifier for reporting',
    cost_to_business_label: 'Cost to business',
    cost_to_business_info:
      'What it costs your business to produce this modifier, including materials and labor.\nFor example, if you’re selling a burger, the cost to business would be the cost of the buns, meat, cheese, veggies.\nIf you don’t know this, a good rule of thumb is 30% of the retail price.',
    cost_to_business_info_v2:
      'What it costs your business to produce this modifier.\nFor example, if you’re selling a burger, the cost to the business would be the cost of the buns, meat, cheese, veggies.\nIf you don’t know this, a good rule of thumb is 50% of the retail price.',
    retail_price_label: 'Retail price',
    retail_price_info:
      'What you normally charge customers for this modifier. It’s the price they pay without any discounts or offers.',
    dollar: '$',
  },
  online_redemption_card: {
    title: 'Online Redemption',
    info_text:
      'Enforce this discount for online purchases by configuring which online items it applies to.',
    will_be_able_to_redeem:
      'Customers will be able to redeem this offer online',
    discounted_label_fallback:
      'Enter product IDs for items that get discounted',
    discounted_label_modifier_fallback:
      'Enter modifier IDs for modifiers that get discounted',
    discounted_label_free_item_fallback:
      'Enter product IDs from your POS for free items',
    discounted_label_free_modifier_fallback:
      'Choose modifiers to include with this offer (optional).',
    discounted_label_modifier_base_item:
      'Modifiers are not included in the fixed price. Consumers will be charged their normal list price for any modifiers added.',
    discounted_label_modifier_all_modifiers:
      "Choose modifiers that must be in the consumer's cart for the fixed price to apply.",
    discounted_label_modifier_required_modifiers:
      'Choose modifiers that are included for the fixed price. Any modifiers not listed will cost the consumer their normal list price.',
    discounted_fixed_price_modifier_title:
      'Modifiers included at the fixed price',
    free_restriction_title:
      'Limit this reward to orders with specific modifiers',
    free_restriction_help_text:
      'At least one of these must be on the item to apply the reward.',
    free_restriction_note_base_item: 'Customer pays for these.',
    free_restriction_note_all_modifiers:
      'Customer gets these modifiers, and all other modifiers on the valid item + modifier combos, for free.',
    free_restriction_disable: 'Disable',
    modifier_discounts_simple_title:
      'Limit this reward to orders with specific modifiers',
    modifier_discounts_simple_help_text:
      'At least one of these must be on the item to apply the reward.',
    modifier_discounts_cheapest_note:
      'The cheapest modifier from the list will be free. Customer pays for all other modifiers.',
    modifier_discounts_required_title: 'Must be present',
    modifier_discounts_required_help_text:
      'Customer must have at least one of these modifiers in cart for the reward to apply. They will pay for it, unless you also select it below.',
    modifier_discounts_title: 'Free when present',
    modifier_discounts_help_text:
      'Customer will only get this modifier for free if they have it in cart. These are not required to apply the reward, unless they are also selected above.',
    modifier_restriction_warning:
      "This modifier restriction applies to all selected items. Any item ordered online without one of these modifiers won't qualify. To include items without modifiers, remove the modifier restriction.",
    base_item_zero_price_warning: {
      heading:
        "The following items have a base price of $0 and can't be used with this offer:",
      body_before_link:
        "This offer only works on items with a price. If you'd like to discount items that use size-based or modifier-based pricing, use ",
      link_text: 'Get a modifier for a fixed price',
      link_new_tab_hint: ' (opens in a new tab)',
      body_after_link: ' instead.',
    },
    no_modifiers_zero_price_warning: {
      heading:
        'The following items have a base price of $0, so this offer only discounts the modifiers you include:',
      body: "Select at least one modifier below. Without one, customers won't get a discount on these items.",
    },
    required_label: 'When a customer purchases any of these items',
    required_modifier_label: 'When a customer purchases any of these modifiers',
    required_label_fallback:
      'Enter product IDs for the items a customer must buy',
    required_modifier_label_fallback:
      'Enter modifier IDs for the modifiers a customer must buy',
    products_required: 'At least one product id must be entered',
    will_apply_lowest:
      "When a customer adds any of these items to their cart, they'll get a discount on the lowest priced one.",
    will_apply_lowest_modifier:
      "When a customer adds any of these modifiers to their cart, they'll get a discount on the lowest priced one",
    will_apply_lowest_free_item:
      'The offer applies to the cheapest matching item in the cart. It covers the full cost, including modifiers.',
    free_items_note_base_item:
      'The offer applies to the cheapest matching item in the cart. Customer pays for modifiers.',
    free_items_note_discounted_modifiers:
      'The offer applies to the cheapest matching item in the cart. It covers the item and the cheapest modifier from the list below.',
    will_apply_lowest_free_modifier:
      'If customer has multiple eligible modifiers in cart, the offer will apply to the cheapest matching modifier.',
    including_addons:
      'You can limit the discount by setting a max discount in your campaign or choosing eligible modifiers below.',
    example: 'Example',
    example_description:
      'If your customer adds a $10 burger to their cart, but they order it with guac (+$3) and an extra patty (+$2), the discount will be off the $15 final cost of the item.',
    then_entire_purchase:
      "Then they'll get a discount off their entire purchase",
    not_redeemable: 'Not redeemable online',
    not_available:
      'Online redemption is only available when you have Thanx Ordering configured. ',
    contact_us: 'Contact us to learn more.',
    add_a_modifier: 'Add a modifier restriction',
    remove_restrictions: 'Remove restrictions',
    which_modifiers: 'Which modifiers the items must have',
    modifier_id_fallback: 'Enter product IDs of modifiers',
    hidden_menu: {
      subtitle:
        'Customers can redeem this reward online (via online ordering or in-app ordering).',
      categories: 'Hidden categories',
      select_description:
        'Changes to your menu may take up to 2 hours to show up in Thanx.',
      category_name: 'Category name',
      category_ids: 'Category Ids (separate by commas)',
      search: 'Search',
      select_category: 'Select category for your hidden menu',
      menu_header: 'Menu header',
      menu_subtitle:
        'Customers will see this message at the top of the menu category in the app and web.',
      show_default: 'Show the default message',
      show_custom: 'Show a custom image',
      congrats: 'Congratulations!',
      unlocked_menu: "You've unlocked a secret menu.",
      no_categories: 'No hidden categories found',
      create_category: 'Create a hidden category with your ordering provider.',
      learn_more: 'Learn more',
      custom_img_descriptor_1:
        'The customer will see this image at the top (app) or left (web) of your menu.',
      custom_img_descriptor_2:
        '<a href="%{url}" target="_blank">Don\'t forget to add text to your image</a> that describes that they unlocked a hidden menu.',
    },
  },
  instore_redemption_card: {
    title: 'In-store Redemption',
    info_desc:
      'Enforce this discount for in-store purchases by configuring how the discount links to the point of sale.',
    manager_comp_desc:
      'The customer opens the reward app and shows the offer to your team member. Your team member manually enters the discount into the point of sale.',
    manager_comp_unavailable:
      'Manager comp not available when in-store offer management is powered by integrations, e.g, Fishbowl, Northstar, etc.',
    coupon_codes_desc:
      'The customer opens the reward app and shows the offer to your team member. The offer has a barcode, QR code, or a coupon code. Your team member scans the code into the point of sale.',
    coupon_codes_enforced_by_pos_desc_1:
      'Manually managed coupon pools: The customer opens the reward app and shows the offer to your team member. The offer has a barcode, QR code, or a coupon code. Your team member scans the code into the point of sale.',
    coupon_codes_enforced_by_pos_desc_2:
      'Integrations between Thanx and the POS: Either Thanx generates a unique code for each customer at redemption. Or the customer identifies themselves at the counter and Thanx tells the POS which offers are available. The experience depends on the integration.',
    coupon_codes_unavailable:
      'Coupon codes are not available for this type of offer.',
    coupon_codes_enforced_by_pos_unavailable:
      'Enforcement by POS is not available for this type of offer.',
    automatic_cash_back_desc:
      'The customer activates automatic cash back in the rewards app. Then they make purchases as usual and do not have to show the offer to a team member. The discount is automatically applied to the purchase as cash back on their credit card statement.',
    automatic_unavailable:
      'Automatic cashback is only available on discounts (e.g. 10% off) and not free items',
    type: {
      manager_comp: 'Manager comp',
      manager_comp_info:
        'Any restrictions must be enforced by a team member or POS at checkout.',
      manager_comp_url: {
        title: 'Where should this image link to?',
        no_url: 'Don’t link to anything',
        url: 'URL ',
        placeholder: 'Enter a valid URL',
      },
      coupon_codes: 'Coupon codes',
      coupon_codes_enforced_by_pos: 'Enforced by POS',
      automatic_cash_back: 'Automatic cash back',
    },
    custom_img_descriptor_1:
      'The customer will see this image after they tap on the offer in the app.',
    custom_img_descriptor_2:
      '<a href="%{url}" target="_blank">Don\'t forget to add text to your image</a> that describes what the customer receives.',
    not_redeemable: 'Not redeemable in-store',

    coupon_codes: {
      will_apply_lowest:
        "When a customer adds any of these items to their cart, they'll get a discount on the lowest priced one.",
      will_apply_lowest_modifier:
        "When a customer adds any of these modifiers to their cart, they'll get a discount on the lowest priced one",
      will_apply_lowest_free_item:
        'The offer applies to the cheapest matching item in the cart. It covers the full cost, including modifiers.',
      free_items_note_base_item:
        'The offer applies to the cheapest matching item in the cart. Customer pays for modifiers.',
      free_items_note_discounted_modifiers:
        'The offer applies to the cheapest matching item in the cart. It covers the item and the cheapest modifier from the list below.',
      will_apply_lowest_free_modifier:
        'If customer has multiple eligible modifiers in cart, the offer will apply to the cheapest matching modifier.',
      including_addons:
        'You can limit the discount by setting a max discount in your campaign or choosing eligible modifiers below.',
      type_label: 'Type',
      discounted_free_item_title: 'Free items',
      discounted_free_item_modifier_title: 'Modifier restrictions (optional)',
      discounted_free_modifier_title: 'Free modifiers',
      discounted_free_modifier_items_title: 'Items',
      discounted_free_item_modifier_help_text:
        'Enter the Modifier IDs from your POS. Make sure to include all Modifier IDs that apply to the items selected above, separated by commas.',
      discounted_label:
        'Enter product IDs from your POS for items that get discounted',
      discounted_label_modifier:
        'Enter modifier IDs from your POS for which modifiers the items must have',
      discounted_label_free_item:
        'Enter product IDs from your POS for free items',
      discounted_label_free_item_modifier:
        'Choose modifiers customers must add to the items above for this offer to apply.',
      discounted_label_modifier_base_item:
        'Modifiers are not included in the fixed price. Consumers will be charged their normal list price for any modifiers added.',
      discounted_label_modifier_all_modifiers:
        "Choose modifiers that must be in the consumer's cart for the fixed price to apply.",
      discounted_label_modifier_required_modifiers:
        'Choose modifiers that are included for the fixed price. Any modifiers not listed will cost the consumer their normal list price.',
      discounted_fixed_price_modifier_title:
        'Modifiers included at the fixed price',
      free_restriction_title:
        'Limit this reward to orders with specific modifier IDs',
      free_restriction_help_text:
        'At least one of these must be on the item to apply the reward.',
      free_restriction_note_base_item: 'Customer pays for these.',
      free_restriction_note_all_modifiers:
        'Customer gets these modifiers, and all other modifiers on the valid item + modifier combos, for free.',
      free_restriction_disable: 'Disable',
      modifier_discounts_simple_title:
        'Limit this reward to orders with specific modifier IDs',
      modifier_discounts_simple_help_text:
        'At least one of these must be on the item to apply the reward.',
      modifier_discounts_cheapest_note:
        'The cheapest modifier from the list will be free. Customer pays for all other modifiers.',
      modifier_discounts_required_title: 'Must be present',
      modifier_discounts_required_help_text:
        'Customer must have at least one of these modifiers in cart for the reward to apply. They will pay for it, unless you also select it below.',
      modifier_discounts_title: 'Free when present',
      modifier_discounts_help_text:
        'Customer will only get this modifier for free if they have it in cart. These are not required to apply the reward, unless they are also selected above.',
      discounted_label_free_modifier:
        'Enter the POS modifier IDs for modifiers customers can get for free.',
      discounted_label_free_modifier_items:
        'Enter the POS product IDs of items eligible for a free modifier.',
      required_label_fallback:
        'Enter product IDs from your POS for items a customer must buy',
      then_entire_purchase:
        "Then they'll get a discount off their entire purchase",
      type_tooltip: {
        pool_title: 'Pool of unique codes',
        pool_content:
          'A long list of one-time use codes used to link the discount to your point of sale. Each customer that gets this offer will see a different coupon code. Each unique code expires after redemption.',
        reusable_title: 'Reusable static code',
        reusable_content:
          'A single code used to link the discount to your point of sale. All customers that get this offer will see the same code.',
        unique_title: 'Integration between Thanx and the POS',
        unique_content_1:
          'With the Toast integration Thanx generates a unique QR code that can be scanned at the POS. Alternatively, the customer can identify themselves at the POS (e.g., via phone or email) and Thanx tells the POS which offers are available for that customer.',
        unique_content_2:
          'With other integrations (Fishbowl, Northstar, etc.) a unique code is generated for each customer at redemption. Each customer that gets this offer will see a different code. Each unique code expires after redemption.',
      },
      format_label: 'Format',
      format_tooltip:
        'How the code appears in the app when the customer redeems the offer. Select the format that your point of sale’s scanner can process (eg. barcode, QR code, etc.). Select raw if the code needs to be entered manually.',
      static_code_label: 'Coupon code',
      static_code_tooltip:
        'A single code used to link the discount to your point of sale. All customers that get this offer will see the same code. This code is usually generated by your point of sale.',
      type: {
        static: 'Reusable static code',
        variable: 'Pool of unique codes',
        dynamic: 'Integration between Thanx and the POS',
      },
      format: {
        raw: 'raw',
        qrcode: 'qrcode',
        barcode39: 'barcode39',
        barcode39extended: 'barcode39extended',
        barcode93: 'barcode93',
        barcode128: 'barcode128',
        barcode_upc_a: 'barcode_upc_a',
        barcode_ean_8: 'barcode_ean_8',
        barcode_ean_13: 'barcode_ean_13',
        barcode25interleaved: 'barcode25interleaved',
      },

      upload: {
        upload_label: 'Upload coupon codes from CSV file',
        upload_format_label:
          'Note - Your CSV file should be formatted as follows:',
        add_more_label: 'Add more coupon codes',
        description: `Or, &nbsp; <a href="${process.env.PUBLIC_URL}/coupon_codes_example.csv"> download a sample CSV</a> to use as a starting point.`,
        tooltip:
          'A CSV file with list of one-time use codes used to link the discount to your point of sale. Each customer that gets this offer will see a different coupon code. Each unique code expires after redemption.',
        batches:
          'Upload codes in batches of 200,000 or less. Larger files may take longer to upload.',
        uploads_list: {
          title: 'Imported coupon codes',
          processing: 'Coupon code import in progress',
          errored: 'Coupon codes failed to import on %{date}',
          finalized: '%{count} coupon codes imported on %{date}',
        },

        table_label: 'Preview of %{filename}',
        column_label: 'Which column has the codes',
        column_option: 'Column %{count}',
        upload_button: 'Upload CSV file',
        continue_button: 'Continue importing',
        cancel_button: 'Cancel',

        processing_1:
          'Your coupon codes are being processed. We’ll send you an email when the import is complete. This process may take a while.',
        processing_2:
          'You can close this page by clicking the save & exit button above and come back later when the import is done.',
        processing_2_template_detail:
          'You can close this page and come back later when the import is done.',

        success: '%{count} codes imported from %{filename}',
        success_with_date: '%{count} codes imported on %{date}',

        error:
          'Failed to upload. This could be caused by a poor internet connection. Try uploading codes in batches of 50,000 or less. Still not working? <a href="mailto: merchant.support@thanx.com">Contact us</a>',
        multiple_columns_detected:
          'Multiple columns detected. The second column will override the display of the redeem code. We recommend using only one column unless you specifically want the second column to replace the display.',
        parse_error:
          'Something went wrong while parsing your file. Please check your file content and try again. <br/> Still not working? <a href="mailto: merchant.support@thanx.com">Contact us</a>',

        table: {
          header: 'Column %{count}',
        },
        format_label: 'Format',
      },
      dynamic: {
        integration: 'Integration between Thanx and the POS',
        entered_by_customer:
          'Each customer will be issued a unique QR code at redemption.<br/>Or customers can enter their phone number or email at the POS.<br/>Then Thanx tells the POS which offers are available to redeem for that customer.',
        issued_5_digit_code:
          'Each customer will be issued a unique 5 digit code at redemption.',
        disabled:
          'Thanx tells the POS which offers are available to redeem for each customer.',
        requires_integration: 'This option requires an integration.',
        learn_more: 'Learn more',
        sample_code: 'Sample code',
        example: '12345',
        contact_us: 'Contact us to learn more.',
      },
      associated_coupon_pools: 'Coupon pools associated with this template',
    },
    image_crop:
      'Placing important graphics outside of the safe area may cause them to be cropped off or covered.',
    multi_pos: {
      title: 'In-store redemption',
      subtitle:
        "You use different POS systems across your locations. The customer's in-store redemption experience will depend on which location and POS they are visiting.",
      which_locations: 'Which locations use which POS?',
      pos: 'POS',
      edit: 'Edit',
      configure: 'Configure',
      configuration: 'Configuration',
      type: 'Type',
      discounted_ids_for_pos: 'Free items',
      discounted_modifier_item_ids_for_pos: 'Items',
      discounted_item_modifier_ids_for_pos: 'Modifier restrictions',
      discounted_modifier_ids_for_pos: 'Free modifiers',
      modifier_discount_ids_for_pos: 'Modifier discounts',
      discounted_item_modifier_text:
        'Any selected items with any selected modifiers are eligible for this offer. If customer has more than one of the items above, the free item will be the lowest priced item in their cart.',
      discounted_modifier_text:
        'Any selected modifiers on any selected items are eligible for this offer. If customer has more than one eligible modifiers, the offer will apply to the lowest priced modifier in their cart.',
      required_ids_for_pos: 'POS product Ids for required items in-store',
      updating_instore_method:
        'Note: Updating the in-store redemption method will not affect offers that have already been delivered to customers.',
      location_config: {
        title: 'Locations and POS',
        contact_us:
          '<a href="mailto:success@thanx.com">Contact us</a> to change the POS associated with a particular location',
        location_header: 'Location',
        pos: 'POS',
      },
    },
  },
  configure_provider: {
    page_title: 'Configure In-store redemption | Thanx',
    configure_title: 'configure',
    title: 'In-store redemption',
    cancel: 'Cancel',
    save_and_return: 'Save & return to offer template',
    help_title: 'Help',
    help: {
      redemption_method: 'How to configure the redemption method of an offer',
      toast_integration: 'How the Toast loyalty integration works',
      coupon_codes: 'How coupon codes generated by Thanx work',
    },
  },
  images: {
    app: 'App',
    app_only: 'App Only',
    web: 'Web',
    online_size: '860px wide',
    index_size: '1,125 x 525px',
    instore_size: '1,284 x 2,780px',
    jpg: 'jpg',
    png: 'png',
    gif: 'gif',
    description: {
      png: 'JPG and PNG: Keep files under 1MB in size. The suggested image width is 1125px.',
      gif: 'GIF: Supported on all app versions for iOS and on app versions 36.0.1 and newer for Android. Keep files under 5MB in size. If needed, make GIF image widths smaller — for example 720px wide — in order to reduce the file size.',
    },
  },
  customer_support_card: {
    title: 'Customer support',
    available_to_grant:
      'Available to grant to an individual customer when responding to customer feedback or providing customer support.',
    not_available_to_grant:
      'Not available to grant to an individual customer when responding to customer feedback or providing customer support.',
  },
  minimum_spend_card: {
    delivery_description:
      'Customers must spend at least this amount (before fees and taxes) to use the offer.',
    title: 'Minimum spend',
    description:
      'Require customers to spend a certain amount in order to receive the discount e.g. Get a free burger when you spend $20 or more.',
    enable: 'Enable',
    disable: 'Disable',
    enable_aria_label: 'Enable minimum spend',
    disable_aria_label: 'Disable minimum spend',
    amount_label: 'Amount',
    input_aria_label: 'Minimum spend amount',
    errors: {
      not_a_number: 'Must be a number',
      negative: 'Must be greater than or equal to 0',
    },
  },
  maximum_discount_card: {
    title: 'Maximum discount',
    description:
      'Set the maximum discount customers can receive e.g. Customer can get up to $50 off.',
    enable: 'Enable',
    disable: 'Disable',
    enable_aria_label: 'Enable maximum discount',
    disable_aria_label: 'Disable maximum discount',
    amount_label: 'Amount',
    input_aria_label: 'Maximum discount amount',
    errors: {
      not_a_number: 'Must be a number',
      negative: 'Must be greater than or equal to 0',
    },
  },
  appearance_card: {
    title: 'Offer appearance',
    subtitle: 'Choose how customers will see this offer in the app.',
    show_default: 'Use the default offer appearance',
    show_custom: 'Use a custom image for the offer',
    redeem: 'Redeem',
    // Bonus-points copy stays "reward" per LOY-623 scope; these disabled-state
    // strings render only when rewardIsDisplayable() is false, i.e. for
    // template.type === 'points/static' (bonus points).
    disabled:
      'This reward will apply instantly the next time customers sign in to the app or web experience. Customers will not see it in the reward list.',
    preview_disabled_1: 'This reward will apply instantly.',
    preview_disabled_2: 'Customers will not see it in the reward list.',
    replace_default:
      'This image will replace the offer text and icon from the default view.',
    custom_img_descriptor_1:
      'The customer will see this image instead of the offer title.',
    custom_img_descriptor_2:
      '<a href="%{url}" target="_blank">Don\'t forget to add text to your image</a> that describes what the customer receives.',
  },
  restrictions: {
    title: 'Restrictions',
    content1:
      'Choose how customers engage with this offer when you create a campaign.',
    content2:
      "When you use this offer in a campaign you'll have the option to choose which customers receive it and add a number of restrictions such as min spend, max discount, customize fine print, and more.",
  },
  modifier_popover: {
    content:
      'Use modifier restrictions to make your offer more specific. If you add modifiers here, the offer will only apply when the selected item(s) also includes the selected modifier(s).',
    example: 'Example',
    example_items:
      '<ul><li>Free chicken burrito</li><li>Free small pizza</li><li>Free bowl with any protein except shrimp</li></ul>',
    footer:
      'Leave this section empty to apply the offer regardless of modifiers.',
    free_item_content:
      'Choose modifiers that the customer must also purchase with one of the items listed above for this offer to apply. Any item in the list above that has no modifier listed below will not be eligible for a discount (as the customer will not be able to meet the restriction requirement).',
    free_item_footer:
      'Remove modifier restrictions to apply the offer regardless of modifiers.',
  },
  multi_use_rewards_card: {
    title: 'Number of uses',
    exactly_once: 'Exactly once',
    exactly_once_description:
      'After this offer is used or expires, no additional offers are issued to the same customer.',
    multiple_times: 'Multiple times',
    multiple_times_description:
      'Customers can redeem this offer more than once, depending on the rules you define.',
    limit_type_label: 'How many times can this offer be used',
    limit_option_set_number: 'Set number of times',
    limit_option_unlimited: 'Unlimited times',
    limit_configuration_label: 'Customers can redeem an offer',
    max_redemptions_label: 'Max total redemptions per user (must be > 1)',
    max_redemptions_validation:
      "Please enter a number greater than 1. Setting it to 1 means the campaign won't send multiple offers.",
    days_available_label:
      'How long the customer has to use all offers after the campaign is sent',
    days_available_help:
      'You can override this setting in offer restrictions when you create a campaign.',
    days_from_issuance: 'days from issuance',
    estimated_max_value: 'Estimated maximum offer cost: $',
    estimated_max_info:
      'This is a rough estimate based on one redemption per eligible day. Actual redemptions may vary depending on customer behavior.',
    add_max_issuances: 'Add max redemptions limit',
    remove_max_issuances: 'Remove max redemptions limit',
    days: 'days',
    times: 'offers',
    every: 'every',
    preset_daily_title: 'Daily Treat',
    preset_daily_description: '1 offer per day',
    preset_weekly_title: 'Weekly Perk',
    preset_weekly_description: '1 offer per week',
    preset_monthly_title: 'Monthly Offer',
    preset_monthly_description: '1 offer per month',
    preset_yearly_title: 'For a Year',
    preset_yearly_description: '1 per week for 52 weeks',
    preset_custom_title: 'Custom',
    preset_custom_description: 'Set your own limits',
    summary_prefix: 'Customers receive',
    summary_frequency: '%{count} offer every %{hours} %{hourLabel}',
    summary_from_issuance: 'from first issuance.',
    summary_max: 'Max %{count} offers over %{duration}.',
    summary_over: 'Over %{duration}.',
    summary_hour: 'hour',
    summary_hours: 'hours',
    customize_link: 'Customize these settings',
    back_to_presets: 'Back to presets',
    reissue_immediately_title: 'Reissue immediately',
    reissue_immediately_description:
      'A new offer is issued right after each redemption. Customer always has an offer available.',
    issue_on_schedule_title: 'Issue on a schedule',
    issue_on_schedule_description:
      'Offers are issued in time windows. Unused offers expire when the window ends.',
    how_it_works: 'How it works',
    issuance_schedule_label: 'Issuance schedule',
    issuance_schedule_issue: 'Issue',
    issuance_schedule_rewards: 'offer(s)',
    issuance_schedule_every: 'every',
    issuance_schedule_days: 'day(s)',
    schedule_expiry_info:
      'Each offer expires after %{hours} hours from when it was issued first. You can manage when the first offer is issued via campaigns.',
    max_rewards_label: 'Max redemptions per customer',
    unlimited_rewards_label:
      'Allow unlimited redemptions within the specified timeframe',
    program_duration_label: 'Timeframe',
    program_duration_tooltip:
      'This defines the duration of the window when the customer is eligible for the offer after they get their first one. You can override this via campaigns by specifying a different timeframe.',
    reissue_summary:
      'Customers receive up to %{count} offers over %{duration}. A new offer is issued immediately after each redemption.',
    schedule_summary:
      'Customers receive up to %{count} offers over %{duration}.',
    how_rounds_work_title: 'How rounds work',
    how_rounds_work_intro: 'Example with 3 offers every 7 days:',
    how_rounds_work_bullet_1: 'Customers receive offer #1 at 9am Monday.',
    how_rounds_work_bullet_2:
      'They redeem it that evening. Offer #2 is issued immediately.',
    how_rounds_work_bullet_3:
      'They redeem offer #2 on Tuesday. Offer #3 is issued immediately.',
    how_rounds_work_bullet_4:
      'Next Monday, at 9am, 7 days after the first issuance, the round ends. The unused offer #3 expires.',
    how_rounds_work_bullet_5:
      'A new round begins automatically with offer #1 issued at 9am.',
    how_rounds_work_round: 'ROUND %{number}',
    how_rounds_work_used: 'Used',
    how_rounds_work_expired: 'Expired',
    how_rounds_work_learn_more: 'Learn more about multi-use offers',
  },
  help: {
    title: 'Help',
    restrictions_help: 'About offer restrictions',
    modifiers_help: 'How to use modifiers in offers',
    restrictions_add_help: 'How to add restrictions to offers',
    hidden_menu_help_1: 'How a hidden menu works',
    hidden_menu_help_2: 'How to configure a hidden menu in Olo',
    golden_ticket_help_1: 'How customers redeem this reward',
    custom_image: 'How to display an offer as a custom image',
    custom_manual_image: 'How to use a custom image for manual redemption',
    get_bonus_points: 'How customers can get bonus points',
  },
  how_to: {
    title: 'How to create this image',
    explainer: 'Explainer video',
    article: 'Help article',
  },
}
